<template>
    <side-container headerTitle="订单详情"
        width="450"
        :isShowFooter="false"
        :isShowFooterBtn="false"
        v-if="visible"
        @close="$emit('update:visible', false)">
        <!-- header -->
        <span slot="header">订单编号：{{ get(rowData, 'order_no') }}</span>
        <!-- section -->
        <section v-if="true" class="section">
            <!-- 收银员信息 -->
            <div class="user-info-and-time fs-14 color-333">
                <user-info v-if="get(rowData, 'creator.id') != null"
                    maxWidth="calc(100% - 150px)"
                    :userInfo="get(rowData, 'creator.user') || {}"/>
                <span v-else>线上自助充值</span>
                <span class="time">{{ get(rowData, 'create_time') }}</span>
            </div>
            <!-- 会员信息 -->
            <order-form-template headerTitle="会员信息">
                <order-form-item :rightContent="`手机：${get(rowData, 'member.phone')}`"
                    :showDashedBottomLine="false">
                    <user-info slot="left"
                        maxWidth="264px"
                        :userInfo="{
                            avatar: get(rowData, 'member.user.avatar'),
                            nickname: get(rowData, 'member.user.nickname'),
                            realname: get(rowData, 'member.name')
                        }"/>
                </order-form-item>
            </order-form-template>
            <!-- 充值信息 -->
            <order-form-template headerTitle="充值信息">
                <div class="show-bottom-dashed-border">
                    <order-form-item :leftContent="'充值金额'"
                        :rightContent="`￥${fixNum(get(rowData, 'recharge_amount'))}`"
                        :showDashedBottomLine="false"/>
                    <order-form-item v-if="get(rowData, 'recharge_bonus') > 0"
                        :leftContent="'充值送'"
                        :rightContent="`￥${fixNum(get(rowData, 'recharge_bonus'))}`"
                        :showDashedBottomLine="false"/>
                </div>
                <order-form-item v-if="get(rowData, 'recharge_bonus') > 0"
                    :showDashedBottomLine="false">
                    <span class="color-999" slot="left">会员余额实际到账</span>
                    <span class="color-999" slot="right">{{ `￥${getSum(get(rowData, 'recharge_amount'), get(rowData, 'recharge_bonus'))}` }}</span>
                </order-form-item>
            </order-form-template>
            <!-- 收款信息 -->
            <order-form-template headerTitle="收款信息">
                <div class="show-bottom-solid-border">
                    <order-form-item :showDashedBottomLine="false">
                        <span class="fw-600" slot="left">应付金额</span>
                        <span slot="right">￥{{ fixNum(get(rowData, 'recharge_amount')) }}</span>
                    </order-form-item>
                </div>
                <order-form-item :showDashedBottomLine="false">
                    <span class="fw-600" slot="left">实付金额</span>
                    <span slot="right" class="fw-600 color-green">￥{{ fixNum(get(rowData, 'actually_paid')) }} <span class="fw-400">({{ get(rowData, 'payment.custom_payment.name') || get(rowData, 'payment.payment_type_text') }})</span></span>
                </order-form-item>
            </order-form-template>
        </section>
    </side-container>
</template>

<script>
import SideContainer from '@/components/layout/side-container-style2.vue'
import OrderFormTemplate from '../../order_form/order_form_detail/modules/order_form_template.vue'
import OrderFormItem from '../../order_form/order_form_detail/modules/order_form_item.vue'
import clone from 'lodash/cloneDeep'
import get from 'lodash/get'
import { fixNum, getSum } from '@/utils/index'
import paymentType from '@/config/payment_type'

export default {
    props: {
        visible: Boolean,
        rowData: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        type() {
            return paymentType
        },
        get() {
            return function(...args) {
                const result = get(...args)
                if (/^\d+\.\d+$/.test(result)) {
                    return +(result)
                } else {
                    return result
                }
            }
        },
        fixNum() {
            return fixNum
        },
        getSum() {
            return getSum
        }
    },
    watch: {
        visible(newVal) {
            if (newVal === true) {
                console.log(clone(this.rowData))
            }
        }
    },
    components: {
        SideContainer,
        OrderFormTemplate,
        OrderFormItem
    }
}
</script>

<style lang="scss" scoped>
.fx-v-center {
    display: flex;
    align-items: center;
}

.section {
    position: relative;
    padding: 12px;

    .user-info-and-time {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .time {
            font-size: 14px;
            color: #333;
        }
    }
}

.show-bottom-dashed-border {
    position: relative;

    &::before {
        content: '';
        position: absolute;
        left: 12px;
        right: 12px;
        bottom: -0.5px;
        border-bottom: 1px dashed #EBEBEB;
    }
}

.show-bottom-solid-border {
    position: relative;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: -0.5px;
        border-bottom: 1px solid #EBEBEB;
    }
}
</style>
